import React, {
  ForwardedRef,
  PropsWithChildren,
  useEffect,
  useImperativeHandle,
  useState,
} from "react"
import { Col, Row } from "react-bootstrap"
import styled from "styled-components"
import AcRequire from "~/components/atoms/AcRequire"
import AcRadio from "~/components/atoms/AcRadio"
import AcSelect from "~/components/atoms/AcSelect"
import AcInput from "~/components/atoms/AcInput"
import AcDatePicker from "~/components/atoms/AcDatePicker"
import AcTimePicker from "~/components/atoms/AcTimePicker"
import AcNumeric from "~/components/atoms/AcNumeric"
import AcCheckBox from "~/components/atoms/AcCheckBox"
import { isMobile } from "~/utils/functions"
import AcBirthdayInput from "../atoms/AcBirthdayInput"
export type KeyValue = { [KEY in string]: any } | any

interface Props {
  name: string
  cellData: any[]
  onChange?: (values: KeyValue) => void
  values?: KeyValue
  isConfirm?: boolean
  disabled?: boolean
  className?: string
  customClassname?: string
}

const Components = {
  Radio: AcRadio,
  Select: AcSelect,
  Input: AcInput,
  Numeric: AcNumeric,
  DatePicker: AcDatePicker,
  TimePicker: AcTimePicker,
  CheckBox: AcCheckBox,
  Birthday: AcBirthdayInput,
}

export interface AcCellAction {
  update: (objectId: string, key: string, data: any) => void
}

export default React.forwardRef(
  (props: PropsWithChildren<Props>, ref: ForwardedRef<AcCellAction>) => {
    //export default function AcCells(props: Props) {
    const {
      name,
      values,
      cellData,
      isConfirm = false,
      disabled = false,
      className,
      onChange,
      customClassname = "",
    } = props

    const hideCheck = (data: any) => {
      const isHide = data?.every((item: any) => Boolean(item.isHide))
      if (!isHide) {
        return !isHide
      }
      return data.every((item: any) => {
        if (typeof item.isHide === "function") {
          //if(values) {
          return item.isHide(values)
          // return Boolean(item.isHide.apply(this, [values]));
          //}
        }
        return false
      })
    }

    const [viewFlags, setViewFlags] = useState([])
    useEffect(() => {
      const flags = []
      cellData.forEach((child, cellIndex) => {
        flags.push(hideCheck(child))
      })
      setViewFlags(flags)
    }, [values])

    //

    const dataObject = {}

    const update = (objectId: string, key: string, data: any) => {
      const element = dataObject[objectId]
      if (element && element[key]) {
        if (Array.isArray(data)) {
          if (Array.isArray(element[key])) {
            element[key].length = 0
            element[key].push(...data)
          } else {
            Object.assign(element[key], data)
          }
        } else {
          Object.assign(element[key], data)
        }
        element.key = new Date().toDateString()
      }
    }

    useImperativeHandle(ref, () => ({
      update,
    }))

    return (
      <>
        {cellData.map((child, cellIndex) =>
          child?.map((data, elementIndex) => {
            // Disable field when confirming
            if (data.confirmDisabled && isConfirm) return null
            if (data?.hide) return null
            return (
              <Cells
                isMobile={isMobile}
                className={`cells ${data.className}`}
                key={`${name}-${cellIndex}-${elementIndex}`}
              >
                {viewFlags[cellIndex] !== false && (
                  <Row className={`${!data.alignStart ? "align-items-center" : ""} `}>
                    {data.title !== null && (
                      <Col xs={3} className={"data-title"}>
                        <h4>{data.title}</h4>
                      </Col>
                    )}
                    <Col xs={1} className="label">
                      {data.required != null &&
                        (data.forceShowRequire ||
                          !data.contents?.every(
                            (item) => item.disabled || disabled || item.data?.disabled
                          )) && <AcRequire required={data.required} />}
                    </Col>

                    <>
                      <Col xs={8} className={"data"}>
                        <Row className={`align-items-center item-row`}>
                          {Array.isArray(data.contents) ? (
                            data.contents.map((content, componentIndex) => {
                              const params = {
                                customClassname,
                                key: componentIndex,
                                name: name ? `${name}-${content.objectId}` : content.objectId,
                                isConfirm,
                                title: content.title,
                                disabled:
                                  content.disabled !== undefined ? content.disabled : disabled,
                                onChange: (value) => {
                                  const newValues = { ...values, [content.objectId]: value }
                                  //setValues(newValues)
                                  onChange?.apply(this, [newValues])
                                },
                                ...content.data,
                                value: content.data?.value
                                  ? content.data?.value
                                  : values?.[content.objectId],
                              }
                              const Component = Components[content.element]
                              const widthCol =
                                content.data?.widthCol && !isConfirm
                                  ? content.data?.widthCol
                                  : (content.data?.col || 12) / data.contents.length
                              let mdCol = content.data?.unit && !isConfirm ? widthCol - 1 : widthCol
                              if (content.title) {
                                mdCol -= 1
                              }
                              if (Component) {
                                dataObject[content.objectId] = params
                                // const element = React.createElement(Component, params)

                                return content.empty ? (
                                  <div className="empty-display">ー</div>
                                ) : (
                                  <>
                                    {content.note && !isConfirm && <>{content.note}</>}
                                    {!!content.title && !isConfirm && (
                                      <Col
                                        md="1"
                                        className={`${
                                          content.alignStart && !isConfirm ? "pb-4" : ""
                                        }`}
                                      >
                                        <div className="text-center">{content.title}</div>
                                      </Col>
                                    )}
                                    {!(isConfirm && content.data?.hideConfirm) && (
                                      <Col
                                        md={mdCol}
                                        key={componentIndex}
                                        className={`${
                                          content.alignStart && !isConfirm ? "pb-4" : ""
                                        }`}
                                      >
                                        {React.createElement(Component, params)}
                                      </Col>
                                    )}
                                    {!!content.data?.unit && !isConfirm && (
                                      <Col
                                        md="1"
                                        className={`${
                                          content.alignStart && !isConfirm ? "pb-4" : ""
                                        }`}
                                      >
                                        <div className="text-center">{content.data?.unit}</div>
                                      </Col>
                                    )}
                                    {!isConfirm && content.data?.textNote}
                                  </>
                                )
                              } else {
                                return (
                                  <>
                                    {!!content.title && !isConfirm && (
                                      <Col md="1">
                                        <div className="text-center">{content.title}</div>
                                      </Col>
                                    )}
                                    {!(isConfirm && content.data?.hideConfirm) && (
                                      <Col md={mdCol} key={componentIndex}>
                                        <p>{content.element}</p>
                                      </Col>
                                    )}
                                    {!!content.data?.unit && !isConfirm && (
                                      <Col md="1">
                                        <div className="text-center">{content.data?.unit}</div>
                                      </Col>
                                    )}
                                  </>
                                )
                              }
                            })
                          ) : (
                            <>{data.contents}</>
                          )}
                        </Row>
                      </Col>
                    </>
                  </Row>
                )}
              </Cells>
            )
          })
        )}
      </>
    )
  }
)

const Cells = styled.div`
  .none {
    display: none;
  }

  .data {
    display: flex;
  }

  .col-md-6 {
    width: ${(props) => `${props.isMobile ? `100%` : `49%`}`};
  }

  .item-row {
    width: 100%;
    margin-bottom: 0px;
    position: relative;
    justify-content: space-between;
  }
  .empty-display {
    height: 52px;
    display: flex;
    align-items: center;
  }
`
